import React, { useState, useEffect } from "react";
import { KeenIcon } from "@/components";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.pageYOffset > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-1/2 right-5 z-50 px-4 py-3 bg-[#304528] text-white rounded-full shadow-lg
        hover:bg-[#2b3d24] focus:outline-none focus:ring-2 focus:ring-[#2b3d24] focus:ring-opacity-50
        transition-all duration-500 ease-in-out transform
        ${isVisible ? "opacity-100 translate-y-0 scale-100" : "opacity-0 translate-y-5 scale-95 pointer-events-none"}
      `}
    >
      <KeenIcon icon="up" />
    </button>
  );
};

export default ScrollToTopButton;
